export default __webpack_public_path__ + "static/media/trash-alt-regular.6b8d6e0a.svg";